import type { SVGProps } from "react";

/**
 * plus-large, add large
 * @category Interface General
 */
export default function IconPlusLarge(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M12 3.75V12M12 12V20.25M12 12H3.75M12 12H20.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
